<app-nav-bar></app-nav-bar>
<div class="container2">
  <router-outlet></router-outlet>
</div>
